// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StarRating_wrapper__21RpE","rc-rate-rtl":"StarRating_rc-rate-rtl__nk8H4"};